"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactQuery = require("react-query");

var _request = require("@nicbase/request");

var _nicbaseSecurity = require("nicbase-security");

var _portalQueryKey = _interopRequireDefault(require("./portalQueryKey"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var findUnassignedBoxesPaginated = function findUnassignedBoxesPaginated(portalId, accountIds, dynamicFilters, dynamicSorters, dynamicPaging) {
  return {
    type: 'FIND_UNASSIGNED_BOXES_BY_FILTER_REQUEST',
    headers: {
      portalId: portalId,
      version: 'v1'
    },
    body: {
      accountIds: accountIds,
      dynamicFilters: dynamicFilters,
      dynamicSorters: dynamicSorters,
      dynamicPaging: dynamicPaging
    }
  };
};

/**
 * Infinite-scroll hook for the DCC Available Devices (unassigned boxes) table.
 *
 * Uses a distinct query key `['unassignedBoxes', queryKeySuffix]` to avoid colliding with
 * sibling queries over the same entity (NPI-3120 gotcha). The default suffix is 'infinite'.
 * Pass `queryKeySuffix: 'badgeCount'` for lightweight count-only queries.
 *
 * @param requestParams - portal id, account ids, optional filters/sorters, page size, and key suffix.
 * @param options       - react-query useInfiniteQuery options.
 * @returns UseInfiniteQueryResult with pages of { unassignedBoxes, total }.
 */
var usePortalUnassignedBoxesPaginated = function usePortalUnassignedBoxesPaginated(requestParams) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _useRequest = (0, _request.useRequest)(),
      request = _useRequest.request;

  var _usePermissions = (0, _nicbaseSecurity.usePermissions)('PORTAL'),
      hasPermissions = _usePermissions.hasPermissions;

  var portalId = requestParams.portalId,
      accountIds = requestParams.accountIds,
      _requestParams$pageSi = requestParams.pageSize,
      pageSize = _requestParams$pageSi === void 0 ? 50 : _requestParams$pageSi,
      _requestParams$dynami = requestParams.dynamicFilters,
      dynamicFilters = _requestParams$dynami === void 0 ? null : _requestParams$dynami,
      _requestParams$dynami2 = requestParams.dynamicSorters,
      dynamicSorters = _requestParams$dynami2 === void 0 ? null : _requestParams$dynami2,
      _requestParams$queryK = requestParams.queryKeySuffix,
      queryKeySuffix = _requestParams$queryK === void 0 ? 'infinite' : _requestParams$queryK;
  return (0, _reactQuery.useInfiniteQuery)([].concat(_toConsumableArray((0, _portalQueryKey["default"])(portalId)), ['unassignedBoxes', queryKeySuffix, dynamicFilters, dynamicSorters]), /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
      var _body$unassignedBoxes, _body$total;

      var _ref$pageParam, pageNumber, dynamicPaging, _yield$request, body;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref$pageParam = _ref.pageParam, pageNumber = _ref$pageParam === void 0 ? 0 : _ref$pageParam;
              dynamicPaging = {
                pageNumber: pageNumber,
                pageSize: pageSize
              };
              _context.next = 4;
              return request(findUnassignedBoxesPaginated(portalId, accountIds, dynamicFilters, dynamicSorters, dynamicPaging));

            case 4:
              _yield$request = _context.sent;
              body = _yield$request.body;
              return _context.abrupt("return", {
                unassignedBoxes: (_body$unassignedBoxes = body === null || body === void 0 ? void 0 : body.unassignedBoxes) !== null && _body$unassignedBoxes !== void 0 ? _body$unassignedBoxes : [],
                total: (_body$total = body === null || body === void 0 ? void 0 : body.total) !== null && _body$total !== void 0 ? _body$total : 0
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), _objectSpread(_objectSpread({
    getNextPageParam: function getNextPageParam(lastPage, allPages) {
      var _allPages$0$total, _allPages$;

      // total is only populated on page 0 — read from allPages[0] so subsequent pages
      // (which return total:0) do not incorrectly stop pagination.
      var total = (_allPages$0$total = (_allPages$ = allPages[0]) === null || _allPages$ === void 0 ? void 0 : _allPages$.total) !== null && _allPages$0$total !== void 0 ? _allPages$0$total : 0;
      var accumulated = allPages.reduce(function (sum, page) {
        return sum + page.unassignedBoxes.length;
      }, 0);

      if (lastPage.unassignedBoxes.length < pageSize || accumulated >= total) {
        return undefined;
      }

      return allPages.length;
    },
    staleTime: 120000
  }, options), {}, {
    enabled: hasPermissions(['module.dccBoxes.read']) && Boolean(portalId) && options.enabled !== false
  }));
};

var _default = usePortalUnassignedBoxesPaginated;
exports["default"] = _default;